import {
  ParameterTimeSeriesConfigurationThresholdsInnerColorEnum,
  ParameterTimeSeriesConfigurationThresholdsInnerThresholdTypeEnum,
  ParameterTimeSeriesConfigurationThresholdsInner,
} from "./types";

/** App alias for the generated parameter time-series threshold shape. */
export type ParameterTimeSeriesThreshold = ParameterTimeSeriesConfigurationThresholdsInner;

/**
 * App-facing aliases over the generated threshold enums. The OpenAPI client
 * names these after `ParameterTimeSeriesConfigurationThresholdsInner`; keep the
 * shorter names used across charts, CMS forms, and map markers.
 */
export type ParameterTimeSeriesThresholdColor =
  ParameterTimeSeriesConfigurationThresholdsInnerColorEnum;
export type ParameterTimeSeriesThresholdType =
  ParameterTimeSeriesConfigurationThresholdsInnerThresholdTypeEnum;

export const ParameterTimeSeriesThresholdTypeEnum =
  ParameterTimeSeriesConfigurationThresholdsInnerThresholdTypeEnum;

export const ParameterTimeSeriesThresholdColorEnum =
  ParameterTimeSeriesConfigurationThresholdsInnerColorEnum;

export const THRESHOLD_TYPE_KEYS = Object.values(
  ParameterTimeSeriesConfigurationThresholdsInnerThresholdTypeEnum,
) as ParameterTimeSeriesThresholdType[];

export const THRESHOLD_COLOR_KEYS = Object.values(
  ParameterTimeSeriesConfigurationThresholdsInnerColorEnum,
) as ParameterTimeSeriesThresholdColor[];

export const DEFAULT_THRESHOLD_TYPE: ParameterTimeSeriesThresholdType =
  ParameterTimeSeriesConfigurationThresholdsInnerThresholdTypeEnum.Max;

export const DEFAULT_THRESHOLD_COLOR: ParameterTimeSeriesThresholdColor =
  ParameterTimeSeriesConfigurationThresholdsInnerColorEnum.Red;

export function isThresholdType(value: string): value is ParameterTimeSeriesThresholdType {
  return (THRESHOLD_TYPE_KEYS as string[]).includes(value);
}

export function isThresholdColor(
  value: string,
): value is ParameterTimeSeriesThresholdColor {
  return (THRESHOLD_COLOR_KEYS as string[]).includes(value);
}

/**
 * A threshold is persistable with a finite value and valid enums.
 */
export function isValidThreshold(threshold: ParameterTimeSeriesThreshold): boolean {
  return (
    typeof threshold.value === "number" &&
    Number.isFinite(threshold.value) &&
    isThresholdType(threshold.threshold_type) &&
    isThresholdColor(threshold.color)
  );
}

export function createDefaultThreshold(): ParameterTimeSeriesThreshold {
  return {
    threshold_type: DEFAULT_THRESHOLD_TYPE,
    value: 0,
    color: DEFAULT_THRESHOLD_COLOR,
  };
}
